import script from "./UserSubscriptionReceipt.vue?vue&type=script&setup=true&lang=js"
export * from "./UserSubscriptionReceipt.vue?vue&type=script&setup=true&lang=js"

import "./UserSubscriptionReceipt.vue?vue&type=style&index=0&id=344a02ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-344a02ff"]])

export default __exports__